// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

export interface MenuItem {
    id: number;
    label: string;
    icon: string;
    routeUrl: string;
}

export class SectionConfig {
    show: boolean = false;
    rolesRequired: string[] = [];
    menuItems: MenuItem[] = [];
}

export class NavigationConfig {
    kithKin: SectionConfig = new SectionConfig();
    menuBar: SectionConfig = new SectionConfig();
    galleryBar: SectionConfig = new SectionConfig();
    galleryCard: SectionConfig = new SectionConfig();
    carPoolCard: SectionConfig = new SectionConfig();
    eventOrganisers: SectionConfig = new SectionConfig();
    exclusiveCard:SectionConfig = new SectionConfig();
    accommodation:SectionConfig = new SectionConfig();
}
